import {useEffect, useState} from 'react';
import classNames from 'classnames';
import {RoutePath} from 'utils/links';
import {Link} from '@shopify/hydrogen';
import {buttonClasses} from './Button.client';
import {Container} from './Container.client';
import {useI18n} from '../contexts/I18n.client';
import {Image} from '@shopify/hydrogen';
import linkpopLogo from '../assets/linkpop-logo.svg';
import linkpopByShopifyLogo from '../assets/linkpop-by-shopify-logo.svg';

const SIGN_UP_ANIMATE_TIMEOUT = 10 * 1000;

export const Header = () => {
  const {t} = useI18n();

  const [shouldAnimateSignUpButton, setShouldAnimateSignUpButton] =
    useState(false);

  useEffect(() => {
    let timeoutId: number | undefined;

    const handleScroll = () => {
      window.removeEventListener('scroll', handleScroll);

      timeoutId = window.setTimeout(() => {
        setShouldAnimateSignUpButton(true);
      }, SIGN_UP_ANIMATE_TIMEOUT);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <header
      className={classNames(
        'sticky',
        'top-0',
        'z-20',
        'border-b-2',
        'border-black',
        'bg-white',
      )}
    >
      <Container className={classNames('flex', 'justify-between', 'h-24')}>
        <div className={classNames('flex', 'items-center')}>
          <Link to={RoutePath.Home}>
            <Image
              className={classNames(
                'min-[400px]:hidden',
                'h-7',
                'hover:cursor-pointer',
              )}
              src={linkpopLogo}
              alt="Linkpop logo"
              width={112}
              height={32}
            />
            <Image
              className={classNames(
                'hidden',
                'min-[400px]:inline',
                'h-7',
                'md:h-8',
                'hover:cursor-pointer',
              )}
              src={linkpopByShopifyLogo}
              alt="Linkpop logo"
              width={200}
              height={32}
            />
          </Link>
        </div>

        <div className={classNames('flex', 'items-center', 'text-sm')}>
          <a
            className={classNames(
              'whitespace-nowrap',
              'font-medium',
              'mr-8',
              'ml-4',
            )}
            href={RoutePath.Dashboard}
            onClick={async (e) => {
              if ('utag' in window) {
                e.preventDefault();
                const {href} = e.currentTarget;

                await new Promise((res) =>
                  window.utag.link(
                    {
                      event_category: 'navigation',
                      event_action: 'text-click',
                      event_label: 'sign in',
                    },
                    res,
                  ),
                );

                window.location.href = href;
              }
            }}
          >
            {t('common.signIn')}
          </a>

          <a
            className={classNames(buttonClasses, {
              'animate-tada': shouldAnimateSignUpButton,
            })}
            data-testid="sign-up-button-header"
            href={RoutePath.AuthSignup}
            onClick={async (e) => {
              if ('utag' in window) {
                e.preventDefault();
                const {href} = e.currentTarget;

                await new Promise((res) =>
                  window.utag.link(
                    {
                      event_category: 'navigation',
                      event_action: 'button-click',
                      event_label: 'sign up for free',
                    },
                    res,
                  ),
                );

                window.location.href = href;
              }
            }}
          >
            <span className={classNames('hidden', 'md:inline')}>
              {t('common.signUpFree')}
            </span>
            <span className="md:hidden">{t('common.signUp')}</span>
          </a>
        </div>
      </Container>
    </header>
  );
};
